<template>
  <div>
    <span>{{entity}}</span>
  </div>
</template>

<script>

    export default {
        name: 'custom-entity',
        props: ['row'],
        components: {

        },
        data() {
            return {
                entity: ''
            }
        },
        mounted() {
            // console.log(this.row.stock.quantity)
          if (this.row) {
            if (this.row.stock) {
              if (this.row.stock.quantity !== 0) {
                this.entity = this.row.stock.quantity
              } else {
                this.entity = "-"
              }
            } else {
              this.entity = "-"
            }
          }

        }
    }

</script>

<style scoped lang="scss">

</style>
